module.exports = __webpack_public_path__ + "faq/img/multiple-account.044862b2.png";